export default __webpack_public_path__ + "static/media/category-science.a356117a.png";